import { gql } from "@apollo/client";
import { MutationResponseWithId } from "../../sharedTypes";

export const DO_EMPTY_FEED = gql`
mutation DoEmptyFeed($domain: String!, $terminalid: Int!, $triggerAmount: Int!, $pauseTime: Int!, $amount: Int!) {
  terminal {
    doEmptyFeed(domain: $domain, terminalid: $terminalid, triggerAmount: $triggerAmount, pauseTime: $pauseTime, amount: $amount) {
      code
      success
      message
    }
  }
}
`

export interface DoEmptyFeed {
  domain: string
  terminalid: number
  triggerAmount: number
  pauseTime: number
  amount: number
}

interface DoEmptyFeedAction {
  code: String
  success: Boolean
  message: string
}

export interface DoEmptyFeedResponse {
  terminal: {
    doEmptyFeed: DoEmptyFeedAction
  }
}


export const DO_EMPTY_FEED_LOCATION = gql`
  mutation DoEmptyFeed($domain: String!, $locationIds: [Int!]!, $triggerAmount: Int!, $pauseTime: Int!, $amount: Int!) {
    location {
      doEmptyFeed(domain: $domain, locationIds: $locationIds, triggerAmount: $triggerAmount, pauseTime: $pauseTime, amount: $amount) {
        code
        message
        success
        id
      }
    }
  }
`

export interface DoEmptyFeedLocation {
  domain: string
  locationIds: number[]
  triggerAmount: number
  pauseTime: number
  amount: number
}

export interface DoEmptyFeedLocationResponse {
  location: {
    doEmptyFeed: MutationResponseWithId[]
  }
}